<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <route-view></route-view>
      <div class="footer">
        <!--TODO <div class="links">
          <a href="http://www.czmpv.com/" target="_blank">帮助</a>
          <a href="http://www.czmpv.com/" target="_blank">隐私</a>
          <a href="http://www.czmpv.com/" target="_blank">条款</a>
        </div> -->
        <div class="copyright">
          Copyright &copy; 2014 - 2021 YuGang. All Rights Reserved
          <!-- Copyright &copy; 2019 Development by Yu Gang Technology -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data () {
    return {}
  },
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
  #userLayout {
    background:#fff url(../assets/images/login-bg.png) no-repeat center center;
    background-size: cover;
  }
  #userLayout.user-layout-wrapper {
    height: 100%;
    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
          &::before {
            display: none;
          }
          &::after {
            display: none;
          }
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      // background: linear-gradient(145deg,rgba(238,232,232,1) 0%,rgba(227,214,231,1) 100%);
      background-size: 100%;
      // padding: 200px 0 144px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        text-decoration: none;
      }

      .main {
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        width:800px;
        height:400px;
        // background:rgba(255,255,255,1);
        // box-shadow:0px 0px 40px 0px rgba(226,201,200,1);
        border-radius:8px;
        // &::before {
        //   content: '\20';
        //   position: absolute;
        //   right: 0;
        //   width:313px;
        //   height:468px;
        //   // background:linear-gradient(223deg,rgba(202,41,66,1) 0%,rgba(224,99,58,1) 100%);
        //   border-radius:214px 8px 8px 214px;
        // }
        // &::after {
        //   content: '\20';
        //   position: absolute;
        //   top: 94px;
        //   right: 27px;
        //   width:382px;
        //   height:318px;
        //   // background:url(https://static.czmpv.com/static/dashboard/homepage_image_1.png) no-repeat center center;
        // }
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;
        .copyright {
          color: #FFFFFF;
          font-size: 14px;
        }
      }
    }
  }
</style>
